import React from 'react'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { useState } from 'react';
import { useEffect } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Util, timesheetApi } from '../../services';
import { Card } from 'primereact/card';
import { classNames } from 'primereact/utils';

export default function DayWiseTimesheet() {
  const [dayWiseData, setDayWiseData] = useState([]);
  const [allocatedProjectData, setAllocatedProjectData] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [employeeList, setEmployeeList] = useState([]);
  const [teamMember, setTeamMember] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [errorLog, SetErrorLog] = useState(false);
  const [isExportDisabled, setIsExportDisabled] = useState(true);

  let count = 0;
  useEffect(() => {
    if (count == 0) {
      fetchAllocatedProjectData();
      count++;
    }
  }, []);

  const fetchAllocatedProjectData = (param = {}) => {
    timesheetApi.getAllProjectByUser(param).then((resp) => {
      try {
        setAllocatedProjectData(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };

  const getProjectByUser = (e) => {
    setSelectedProject(e.value);
    var idList = [];
    e.value.map((item, key) => {
      idList[key] = item.id;
    })
    let param = {
      projectIds: idList
    }
    timesheetApi.getUsersByProjectIdInDayWise(param).then((resp) => {
      try {
        var memberListing = [];
        resp.data.data.map((item) => {
          let objMember = {
            id: item.id,
            name: item.firstName.charAt(0).toUpperCase() + item.firstName.slice(1) + " " + item.lastName.charAt(0).toUpperCase() + item.lastName.slice(1),
          };
          memberListing.push(objMember);
        });
        setEmployeeList(memberListing);
      } catch (error) {
        // Error handle
      }
    });
  }

  const validateError = () => {
    if (selectedProject === null || dateRange === undefined || teamMember === null) {
      SetErrorLog(true);
      return true;
    }
  };

  const filterDayWiseTimesheet = (e) => {
    var memberList = [];
    teamMember?.map((item, key) => {
      memberList[key] = item?.id;
    })

    var projectList = [];
    selectedProject?.map((item, key) => {
      projectList[key] = item?.id;
    })

    const error = validateError();

    if (error) {
    } else {
      let param = {
        fromDate: Util.dateConverter(dateRange[0]),
        toDate: Util.dateConverter(dateRange[1]),
        projectIds: projectList,
        userIds: memberList
      }
      timesheetApi.dayWiseTimesheetData(param).then((resp) => {
        try {
          setDayWiseData(resp.data.data);
          if (resp?.data?.data?.length > 0) {
            setIsExportDisabled(false);
          }
        } catch (error) {
          // Error handle
        }
      });
    }
  };

  const exportExcel = () => {
    import('xlsx').then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(dayWiseData);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      Util.saveAsExcelFile(excelBuffer, 'Day-Wise-Timesheet');
    });
  }

  const DayWiseFilter = (e) => {
    return (
      <React.Fragment>
        <div className="grid">
          <div className="field col-1 mt-4" style={{ width: "55px", fontWeight: "700", marginTop: "6px" }}>
            Filter :
          </div>

          <div className="field col-2 mt-2 mr-3">
            <MultiSelect filter value={selectedProject} options={allocatedProjectData} onChange={(e) => getProjectByUser(e)} optionLabel="title" placeholder="Select Project" maxSelectedLabels={1} showClear style={{ width: "158px" }} className={classNames({ "p-invalid": errorLog && !selectedProject }, "mt-2")} />
            {errorLog && (
              <span>
                {selectedProject === null && (
                  <div style={{ color: "red" }}>Select Project!</div>
                )}
              </span>
            )}
          </div>

          <div className="field col-3 mt-2 ml-3">
            <Calendar id="range" value={dateRange} onChange={(e) => setDateRange(e.value)} selectionMode="range" readOnlyInput dateFormat="dd/mm/yy" mask="99/99/9999" showIcon placeholder="Select Date Range" className={classNames({ "p-invalid": errorLog && !dateRange }, "mt-2")} />
            {errorLog && (
              <span>
                {dateRange === undefined && (
                  <div style={{ color: "red" }}>Select Date Range!</div>
                )}
              </span>
            )}
          </div>

          <div className="field col-2 mt-2 mr-4">
            <MultiSelect filter value={teamMember} options={employeeList} onChange={(e) => setTeamMember(e.value)} optionLabel="name" placeholder="Select Employee" maxSelectedLabels={1} showClear style={{ width: "158px" }} className={classNames({ "p-invalid": errorLog && !teamMember }, "mt-2")} />
            {errorLog && (
              <span>
                {teamMember === null && (
                  <div style={{ color: "red" }}>Select Employee!</div>
                )}
              </span>
            )}
          </div>

          <div className="field col-1 ml-3 mr-1 mt-3">
            <Button label="Filter" className="p-button-rounded" icon="pi pi-search" type="button" onClick={filterDayWiseTimesheet} />
          </div>

          <div className="field col-1 ml-3 mt-3">
            <Button label="Export" className="p-button-rounded p-button-info" icon="pi pi-download" type="button" onClick={exportExcel} disabled={isExportDisabled} />
          </div>
        </div>
      </React.Fragment>
    );
  };

  const fetchBillingTypeColor = (billingType) => {
    if (billingType === "Chargeable") return "#008000";
    if (billingType === "Non-Chargeable") return "#ff0000";
  };

  const billingTypeTemplate = (item) => {
    return (
      <span style={{ color: fetchBillingTypeColor(item.billingType) }}>{item.billingType}</span>
    )
  }

  const fetchStatusColor = (status) => {
    if (status === "LOCKED") return "#ff0000";
    if (status === "APPROVED") return "#008000";
    if (status === "REVIEW") return "#236ee3";
  };

  const approvalStatusTemplate = (item) => {
    return (
      <span style={{ color: fetchStatusColor(item.status) }}>{item.status}</span>
    );
  };

  return (
    <div>
      <Card className="">
        <Toolbar className="mb-4" left={DayWiseFilter}></Toolbar>
        <DataTable paginator value={dayWiseData} responsiveLayout="scroll" scrollable stripedRows paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}>
          <Column field="buProject" header="BU" sortable style={{ minWidth: "5rem" }}></Column>
          <Column field="ecn" header="ECN" sortable style={{ minWidth: "5rem" }}></Column>
          <Column field="name" header="Employee Name" className="capitalize" sortable style={{ minWidth: "13rem" }}></Column>
          <Column field="pmName" header="Timesheet Approver" sortable style={{ minWidth: "14rem" }}></Column>
          <Column field="timesheetId" header="Timesheet ID" sortable style={{ minWidth: "13rem" }}></Column>
          <Column field="activity" header="Activity" sortable style={{ minWidth: "10rem" }}></Column>
          <Column field="category" header="Category" sortable style={{ minWidth: "8rem" }}></Column>
          <Column field="description" header="Description" sortable style={{ minWidth: "13rem" }}></Column>
          <Column field="taskID" header="Task ID" sortable style={{ minWidth: "8rem" }}></Column>
          <Column field="timesheetDate" header="Timesheet Date" sortable style={{ minWidth: "13rem" }}></Column>
          <Column field="projectID" header="Project ID" sortable style={{ minWidth: "10rem" }}></Column>
          <Column field="projectName" header="Project Name" sortable style={{ minWidth: "15rem" }}></Column>
          <Column field="hours" header="Hours" sortable style={{ minWidth: "5rem" }}></Column>
          <Column field="" header="Billing Type" body={billingTypeTemplate} style={{ minWidth: "10rem" }}></Column>
          <Column field="month" header="Month" sortable style={{ minWidth: "6rem" }}></Column>
          <Column field="year" header="Year" sortable style={{ minWidth: "5rem" }}></Column>
          <Column field="" header="Timesheet Approval Status" body={approvalStatusTemplate} style={{ minWidth: "16rem" }}></Column>
        </DataTable>
      </Card>
    </div>
  )
}